import { useTranslate } from "@made-people/grease-translations";
import { FaqQnaItems } from "./faq-qna-items";
import { parseFaqItems } from "./parse-faq-items";

export const ProductFaq = ({ faq }: { faq: unknown }) => {
  const translate = useTranslate();
  const items = parseFaqItems(faq);
  if (!items.length) return null;

  return (
    <div className="rounded-md px-6 py-10 col-start-1 col-span-12 lg:col-span-6 lg:row-start-10 mt-4 lg:mt-0 mb-2">
      <h2 className="font-secondary text-heading-md lg:text-heading-lg text-left pb-6 lg:pb-7">
        {translate("FAQ_title_pdp_plp")}
      </h2>
      <FaqQnaItems items={items} />
    </div>
  );
};
